var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Expose, Exclude, Type, Transform } from 'class-transformer';
import { ArchiveAndRestoreStorageType, S3AuthenticationTypes } from '@logz-pkg/enums';
class S3Secret {
    accessKey;
    secretKey;
}
class S3Iam {
    arn;
    externalId;
}
class S3Storage {
    credentialsType;
    path;
    secret;
    iam;
}
__decorate([
    Type(() => S3Secret),
    Expose({ name: 's3SecretCredentials' }),
    __metadata("design:type", S3Secret)
], S3Storage.prototype, "secret", void 0);
__decorate([
    Type(() => S3Iam),
    Expose({ name: 's3IamCredentials' }),
    __metadata("design:type", S3Iam)
], S3Storage.prototype, "iam", void 0);
class BlobStorage {
    tenantId;
    clientId;
    clientSecret;
    accountName;
    containerName;
    // Remove after fix https://logzio.atlassian.net/browse/DEV-26406
    path;
}
__decorate([
    Transform(value => (value === '' ? null : value), { toPlainOnly: true }),
    __metadata("design:type", String)
], BlobStorage.prototype, "path", void 0);
let ArchiveSettingsModel = class ArchiveSettingsModel {
    // Because of inconsistency in API the id is populated manually in api.server
    id;
    isEnabled;
    isCompressed;
    storageType;
    s3 = new S3Storage();
    blob = new BlobStorage();
    isAwsWithIAMSettings() {
        return (this.storageType === ArchiveAndRestoreStorageType.AWS && this.s3?.credentialsType === S3AuthenticationTypes.IAM);
    }
};
__decorate([
    Expose({ name: 'enabled' }),
    __metadata("design:type", Boolean)
], ArchiveSettingsModel.prototype, "isEnabled", void 0);
__decorate([
    Expose({ name: 'compressed' }),
    __metadata("design:type", Boolean)
], ArchiveSettingsModel.prototype, "isCompressed", void 0);
__decorate([
    Expose({ since: 2 }),
    __metadata("design:type", String)
], ArchiveSettingsModel.prototype, "storageType", void 0);
__decorate([
    Expose({ name: 'amazonS3StorageSettings' }),
    Transform(value => value ?? new S3Storage(), { toClassOnly: true }),
    Type(() => S3Storage),
    __metadata("design:type", S3Storage)
], ArchiveSettingsModel.prototype, "s3", void 0);
__decorate([
    Expose({ name: 'azureBlobStorageSettings' }),
    Transform(value => value ?? new BlobStorage(), { toClassOnly: true }),
    Type(() => BlobStorage),
    __metadata("design:type", BlobStorage)
], ArchiveSettingsModel.prototype, "blob", void 0);
ArchiveSettingsModel = __decorate([
    Exclude()
], ArchiveSettingsModel);
export { ArchiveSettingsModel };
//# sourceMappingURL=archive-settings.js.map